import { useWebsiteBuilder } from '../context/WebsiteBuilderContext';
import SitemapGenerator from '../components/SitemapGenerator';
import { usePageTracking } from '../../../hooks/usePageTracking';

export default function SitemapStepPage() {
  const { nodes, setNodes, isExported, triggerChargeConfirm, currentStep } = useWebsiteBuilder();
  usePageTracking({ moduleName: 'Website Builder', submoduleName: 'Sitemap', routePath: '/website-builder/sitemap' });

  return (
    <SitemapGenerator
      nodes={nodes}
      setNodes={setNodes}
      isExported={isExported}
      onRequestUnlock={() => triggerChargeConfirm('unlock')}
    />
  );
}
